import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { toast } from "sonner";
import { ROLE_LABELS, ROLE_DESCRIPTIONS } from "../../lib/utils";
import SettingsSection from "./SettingsSection";

const ROLE_ORDER = ["super_admin", "project_manager", "team_member", "client_admin", "client_user"];

const TONE = {
  super_admin: "bg-rose-50 text-rose-700 border-rose-200",
  project_manager: "bg-blue-50 text-blue-700 border-blue-200",
  team_member: "bg-violet-50 text-violet-700 border-violet-200",
  client_admin: "bg-amber-50 text-amber-700 border-amber-200",
  client_user: "bg-slate-100 text-slate-700 border-slate-200",
};

export default function RolesPanel() {
  const [perms, setPerms] = useState(null);
  useEffect(() => {
    api.get("/company/permissions").then((r) => setPerms(r.data)).catch(() => {});
  }, []);
  const toggleStaffTickets = async (checked) => {
    try {
      const { data } = await api.patch("/company/permissions", { staff_ticket_creation: checked });
      setPerms(data);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Failed to update permission");
    }
  };
  return (
    <SettingsSection title="Roles" description="What each role can do. Roles are fixed and apply across every industry.">
      <div className="surface-card divide-y divide-slate-100" data-testid="roles-reference">
        {ROLE_ORDER.map((key) => {
          const d = ROLE_DESCRIPTIONS[key];
          return (
            <div key={key} className="p-4 flex flex-col sm:flex-row sm:items-start gap-3">
              <span className={`inline-flex shrink-0 items-center px-2.5 py-0.5 rounded-full text-[10px] font-medium border uppercase tracking-wide ${TONE[key]}`}>
                {ROLE_LABELS[key]}
              </span>
              <div className="min-w-0">
                <div className="text-sm text-slate-700">{d.blurb}</div>
                <div className="text-xs text-slate-400 mt-0.5"><span className="font-medium text-slate-500">Access:</span> {d.access}</div>
              </div>
            </div>
          );
        })}
      </div>
      <div className="surface-card p-5" data-testid="role-permissions">
        <div className="text-sm font-semibold text-slate-800">Permissions</div>
        <label className="mt-3 flex items-start gap-2.5 text-sm text-slate-700">
          <input
            type="checkbox"
            className="mt-0.5"
            disabled={perms === null}
            checked={!!perms?.staff_ticket_creation}
            onChange={(e) => toggleStaffTickets(e.target.checked)}
            data-testid="staff-ticket-creation-toggle"
          />
          <span>
            Allow project managers and team members to create tickets on behalf of clients
            <span className="block text-xs text-slate-400 mt-0.5">
              When off, only client users, client admins and super admins can raise tickets. Staff pick the client&apos;s project on the form, so the ticket lands in that client&apos;s workspace.
            </span>
          </span>
        </label>
      </div>
    </SettingsSection>
  );
}
